/* eslint-disable @typescript-eslint/no-empty-function */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-08-27 14:16:43
 */
import {
  CaretDownFilled,
  CaretRightFilled,
  CloseOutlined,
  ExclamationCircleFilled,
  InfoCircleOutlined,
  PlusOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import DraggableModal from '../DraggableModal'
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import Draggable from 'react-draggable'
import { TabPane } from '../../../compnents/widgets/TabBar'
import AiTreatment from '../aiTreatment'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
  Typography,
  Tabs,
  Menu,
  Radio,
  Popover,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import * as U from '../../../models/user'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { Label } from '../../../compnents/widgets/Label'
import { ThemeContext } from '../../../theme/ThemeContext'
import styles from './blindPersonmedical.module.css'
import { getDoctorsInDepartmentListAsync, getOutpatientDepartments, selectDoctorsInDepartments, selectOutpatientDepartments } from '../../completion/completionSlice';
import { DiagnosisTemplate } from './diagnosisTemplate';
import { DateTimeFormat, DateTimeFormatSimple, DateTimeFormatSimpleOnly, DateTimeFormatSimpleOnlyOne } from '../../../models/datetime';
import { getRecipeList, getTreatmentNotice, setRecipeEditorTreatment } from '../editor/recipeListEditorSlice';
import { getMedicalRecordsShow, getTcmTreatmentOldList } from '../list/treatmentSlice';
import { HistoryPanel } from '../tcmCases/historyPanel';
import { selectAppToken, selectCredentials, selectEdition, selectInsuranceArray, selectTenantAddress, selectTenantAreaCd, selectTenantCategory, selectTenantName, selectUserDepartmentId, selectUserId, selectUserName } from '../../../app/applicationSlice';
import { useQuery } from '../../../utils/HttpUtils';
import { copyTreatment, createTreatment, getTreatment, getUrl, resetTcmCase, selectRegistration, selectTreatmentCreatingState, selectTreatmentT, setTreatmentCreatingState, startTreatment } from '../tcmCases/tcmCasesSlice';
import { CopyTreatmentParams } from '../../../services/treatment';
import { DateRangeType, getDateRange } from '../../../compnents/date/TimeSelect';
import { selectBooleanSetting } from '../../settings/settingsSlice';
import { Settings } from '../../../models/setting';
import { selectInsuranceItem, setInsurance } from '../../../layouts/insuranceSlice';
import { Disease } from '../../../models/disease';
import { Treatments, TreatmentsRef } from '../list/Treatments';
import { getTreatmentCategoryName, TreatmentCategories, TreatmentCategoriesCQ, TreatmentCategoriesJS, TreatmentCategoriesZF, TreatmentCategory, TreatmentNotice } from '../../../models/treatment';
import { CopyRecipeParams } from '../../../services/recipe';
import { HydGPTRun } from '../../../utils/HydGPT';
import { FastInput } from '../tcmCases/fastInput';
import TextArea from 'antd/lib/input/TextArea';
import FileUpload from '../../../compnents/file/FileUpload';
import { RcFile, UploadFile } from 'antd/lib/upload/interface';
import AiAgreement from '../AiAgreement';
import { DiseaseInput } from '../../../compnents/input/DiseaseInput';
import { getUserProfileList } from '../../personalManagement/personalDetail/personalDetailSlice';
import AILoading from "../../../layouts/img/ailoading.gif";
import { Patient } from '../../../models/patient';
import { getPatientDetail } from '../../patient/patientSlice';
import { copyTreatmentRecipe, deleteUploadFileList, getSelectSpecialDiseaseIcd10 } from '../diagnosis/diagnosisSlice';
import { searchMedicalAsync, selectSearchMedical } from '../../registration/register/registerSlice';
import { TemplateCategory } from '../../../models/template';
import { traceRoute } from '../../../layouts/layoutSlice';
import { VisitType } from '../../../models/registration';
import { LoadingState } from '../../../models/common';
import { PreferencesSetModal } from '../diagnosis/preferencesSetModal';
import { UploadModal } from '../../putstorelist/Query/uploadModal';
import { getCounselor } from '../../A-toothModule/toothHome/toothHomeSlice';
import { PrintTemplateCategory } from '../../../models/print';
import { PrintTemplateModal } from '../../print/PrintTemplateModal';
import { RecipeStatus } from '../../../models/recipe';
import { SaveTemplateModal } from '../../template/SaveTemplateModal';
import { getTempalteDetailList } from '../../template/templateSlice';
import { LookPicModal } from './lookPicModal';
import { getBlindFileListPage, getCounselorListTimePage, getDoctorsInDepartmentTimeListAsync } from './blindPersonmedicalSlice';
import { number } from 'echarts';
import { pinyin } from 'pinyin-pro';
import { selectSettings } from '../../user/setting/settingSlice';
import { HistoricalEpidemiologyFastInput } from '../editor/components/HistoricalEpidemiologyFastInput';

const { Text } = Typography

export interface TcmcaseRef {
  submit: () => Promise<void>
  showTreatments: () => void
}

interface TcmCasesProps {
  readMode?: boolean
  state?: number
  saveEdit?: () => void
  registrations?: any
  owelabel?: any
  oweMoneyNum?: any
  oweMoneyShow?: any
  insuranceBean?: any
  patientInsurance?: any
  PreferencesSetChange?: () => void
}

const BlindPersonmedicalCase = (
  {
    readMode = false,
    state = undefined,
    saveEdit = () => { },
    registrations,
    owelabel,
    oweMoneyNum,
    oweMoneyShow,
    insuranceBean,
    patientInsurance,
    PreferencesSetChange,
  }: TcmCasesProps,
  ref: React.Ref<TcmcaseRef>
) => {
  const layout = {
    labelCol: { flex: '4rem' },
    wrapperCol: { flex: 1 },
  }

  const columnLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  const { CheckableTag } = Tag

  const { Option } = Select

  const { Panel } = Collapse

  const query = useQuery()

  const theme = useContext(ThemeContext)

  const settings = useSelector(selectSettings)
  
  const lxbxsNewFlag = settings?.[105]?.includes('1102') //新版 各项流行病学史齐全

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const treatmentsRef = useRef<TreatmentsRef>(null)

  const patientSystolicPressureRef = useRef<any>(null)

  const patientDiastolicPressureRef = useRef<any>(null)

  const patientPulseRef = useRef<any>(null)

  const patientHeightRef = useRef<any>(null)

  const patientWeightRef = useRef<any>(null)

  const [treatmentForm] = Form.useForm()

  const [BlindPersonForm] = Form.useForm()

  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const registrationId = query.get('registrationId') as string

  const treatmentId = query.get('treatmentId') as string

  const credentials = useSelector(selectCredentials)

  const searchMedical = useSelector(selectSearchMedical)

  const treatment = useSelector(selectTreatmentT)

  const departmentId = useSelector(selectUserDepartmentId)

  const token = useSelector(selectAppToken)

  const registration = useSelector(selectRegistration)

  const insuranceArray = useSelector(selectInsuranceArray)

  const userName = useSelector(selectUserName)

  const userId = useSelector(selectUserId)

  const cycleCode = sessionStorage.getItem('cycleCode')

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const tenantName = useSelector(selectTenantName)

  const tenantCategory = useSelector(selectTenantCategory)

  const aiSwitch = useSelector(
    selectBooleanSetting(Settings.AI.MAIN_SWITCH)
  )

  const creatingState = useSelector(selectTreatmentCreatingState)

  const baseData = useSelector(selectInsuranceItem)

  // const doctors = useSelector(selectDoctorsInDepartments)

  const departments = useSelector(selectOutpatientDepartments)

  const [settledState, setSettledState] = useState(false)

  const [doctors, setDoctors] = useState<any[]>()

  const [treatmentAssistantDoctorList, setTreatmentAssistantDoctorList] = useState<any[]>() //  助理医师数据

  const [targetTemplate, setTargetTemplate] = useState<any>(undefined)

  const [templates, setTemplates] = useState<TemplateCategory[]>([])

  const [SaveTemplateModalVasible, setSaveTemplateModalVasible] = useState(
    'false'
  )

  const [patient, setPatient] = useState<Patient | undefined>()

  const [isDiseaseEditable, setIsDiseaseEditable] = useState(true)

  const [isDiseaseEmpty, setIsDiseaseEmpty] = useState(false)

  const [isOpen, setIsOpen] = useState(false)

  const [checkData, setCheckData] = useState<any>([])

  const [notice, setNotice] = useState<TreatmentNotice | undefined>()

  const [copyRecipeFlag, setCopyRecipeFlag] = useState<any>(false)

  const [isTipsModalVisible, setIsTipsModalVisible] = useState<any>()

  const [tempType, setTempType] = useState(false)

  const [isDoctorEditable, setIsDoctorEditable] = useState(!readMode)

  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false)

  const [printLoading, setPrintLoading] = useState(false)

  const [selectedDiseases, setSelectedDiseases] = useState<Disease[]>([])

  const [againDiagnoseType, setAgainDiagnoseType] = useState(false)

  const [seeOtherDoctor, setSeeOtherDoctor] = useState(true)

  const [historyList, setHistoryList] = useState<any>([])

  const [CollapseActivekey, setCollapseActivekey] = useState('0')

  const [historyData, setHistoryData] = useState<any>({})

  const [reuseTreatmentId, setReuseTreatmentId] = useState('')

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [isCopyReciptModalVisible, setIsCopyReciptModalVisible] = useState(
    false
  )

  const [isCopyReciptParam, setIsCopyReciptParam] = useState<any>()

  const [restoreFlag, setRestoreFlag] = useState(false)

  const [deleteFlag, setDeleteFlag] = useState<any>(false)

  const [aiBtnText, setAiBtnText] = useState('')

  const [aiLargeVisible, setAiLargeVisible] = useState(false)

  const [aiPlusText, setAiPlusText] = useState('')

  const [aicheckDone, setAicheckDone] = useState(true)

  const [fileList, setFileList] = useState<UploadFile[]>([])

  const [isLookPicModalVisible, setIsLookPicModalVisible] = useState(false)

  const [isUploadVisible, setIsUploadVisible] = useState(false) //上传附件弹窗

  const [lookPic, setLookPic] = useState('')

  const [patientSystolicPressureValue, setPatientSystolicPressureValue] = useState<any>()

  const [patientDiastolicPressureValue, setPatientDiastolicPressureValue] = useState<any>()

  const [diseaseOptions, setDiseaseOptions] = useState<any>()

  const [inputValues, setInputValues] = useState<Record<string, string>>({});

  const [inputIcds, setInputIcds] = useState<Record<string, string>>({});

  const [isCreating, setIsCreating] = useState(false)

  const [preferencesSetShow, setiPreferencesSetShow] = useState(false) //偏好设置

  const [mlBtnLoading, setmlBtnLoading] = useState(false)
  const [cfBtnLoading, setcfBtnLoading] = useState(false)
  const [kcBtnLoading, setkcBtnLoading] = useState(false)

  const [lookPicList, setLookPicList] = useState<any[]>([])

  const [lastUploadTime, setLastUploadTime] = useState('')

  const [isLookPicListModalVisible, setIsLookPicListModalVisible] = useState(false)

  interface AiMessage {
    role: string;
    content: string;
  }
  const [aiMsg, setAiMsg] = useState<AiMessage[]>([]);

  useEffect(() => {
    if (!treatment) {
      setIsDiseaseEditable(true)
      return
    }
    if (treatment?.disease) {
      if (readMode) {
        setIsDiseaseEditable(false)
      }
      setSelectedDiseases(
        treatment?.disease
          .split(',')
          .map((d: any) => d.split('/'))
          .map((pair: any) => ({ name: pair[0], icds: pair[1] } as Disease))
      )
      setIsDiseaseEmpty(false)
    } else {
      setSelectedDiseases([])
    }
    BlindPersonForm.setFieldsValue({
      ...treatment,
      disease: '',
      allergen: BlindPersonForm.getFieldValue('allergen') || treatment.allergen ,
      personalHistoryEnable: !!treatment.personalHistory,
      familyHistoryEnable: !!treatment.familyHistory,
      vaccineHistoryEnable: !!treatment.vaccineHistory,
      menstrualHistoryEnable: !!treatment.menstrualHistory,
      maritalHistoryEnable: !!treatment.maritalHistory,
      infectiousDisease: treatment.infectiousDisease === 1,
    })
    getPatientDetailData()
    if (treatment?.patientWeight && treatment?.patientHeight) {
      const BMI = (
        (treatment?.patientWeight /
          (treatment?.patientHeight * treatment?.patientHeight)) *
        10000
      ).toFixed(1)
      BlindPersonForm.setFieldsValue({
        BMI,
      })
    }

    treatmentForm.setFieldsValue({
      treatmentCategory:
        treatment.treatmentCategory === TreatmentCategory.Special
          ? TreatmentCategory.Special
          : TreatmentCategory.Normal,
      // infectiousDisease: treatment.infectiousDisease === 1,
    })
    setAgainDiagnoseType(againDiagnoseType || treatment.receiveTag === VisitType.Subsequence)
    setReuseTreatmentId(reuseTreatmentId || treatment?.reuseTreatmentId || '')
    if (readMode) {
      setIsDoctorEditable(
        treatment.treatmentDepartmentId === '0' ||
        treatment.treatmentDoctorId === '0'
      )
      if (!registration?.treatmentDoctorId && treatment.treatmentDoctorId) {
        getDoctorList(treatment.treatmentDepartmentId)
      }
      const flag = doctors?.find(
        (d) =>
          d.id ==
          (treatment.treatmentDoctorId === '0'
            ? undefined
            : treatment.treatmentDoctorId)
      )
      if (
        !registration?.registrationDepartmentId &&
        !registration?.treatmentDoctorId
      ) {
        const doctorName = doctors?.find(
          (d) =>
            d.id ===
            (treatment.treatmentDoctorId === '0'
              ? undefined
              : treatment.treatmentDoctorId)
        )?.name
        treatmentForm.setFieldsValue({
          treatmentDepartmentId:
            treatment.treatmentDepartmentId === '0'
              ? undefined
              : treatment.treatmentDepartmentId,
          treatmentDoctorId:
            treatment.treatmentDoctorId === '0'
              ? undefined
              : treatment.treatmentDoctorId,
        })
      }
    }
    treatment.coherentVideo
      ? setFileList(
        treatment.coherentVideo.split(',').map((v: any) => {
          return ({
            name: v.split('@')[0],
            uid: v.split('@')[1] ? v.split('@')[1] : v.split('@')[0],
            url: v.split('@')[2] ? v.split('@')[2] : v.split('@')[0],
          } as unknown) as UploadFile
        })
      )
      : setFileList([])
  }, [treatment])

  useEffect(() => {
    BlindPersonForm.setFieldsValue({
      treatmentCategory: 0,
    })
    return () => {
      dispatch(resetTcmCase())
    }
  }, [])

  useEffect(() => {
    dispatch(setRecipeEditorTreatment(treatment))
  }, [treatment])

  useEffect(() => {
    if (!aiSwitch) {
      return;
    }
    if (!registration || registration == null) {
      return;
    }
    // 检查是否已经显示过引导
    const hasShownGuide = localStorage.getItem('aiGuideShown');
    //暂时关闭
    return;
    if (hasShownGuide != null && hasShownGuide == '1') {
      return; // 如果已经显示过，就不再次显示
    }
    const driverObj = driver({
      steps: [
        {
          element: '.first-feature',
          popover: {
            title: 'AI助您写病历',
            description: '只需填写简要的诊断信息，即可一键生成完善精确的电子病历。',
            side: 'top', // 使用 side 而不是 position
            nextBtnText: "下一个"

          }
        },
        {
          element: '.second-feature',
          popover: {
            title: 'AI辅诊助您分析病情',
            description: '根据历史病历、医保历史信息等因素进行AI分析，并给出理性的治疗意见。',
            side: 'top', // 使用 side 而不是 position
          }
        }
      ],
      overlayOpacity: 0.5,
      animate: true,
      doneBtnText: '我知道了 ✓',
      showButtons: ["next", "close"],
      // 监听引导销毁事件
      onDestroyed: () => {
        // 将引导状态记录到 localStorage
        localStorage.setItem('aiGuideShown', '1');
        console.log('引导已结束，状态已保存');
      },

      // 也可以监听关闭事件
      onCloseClick: () => {
        localStorage.setItem('aiGuideShown', '1');
        console.log('用户主动关闭引导');
      }
    });

    // 自动开始引导
    setTimeout(() => {
      driverObj.drive();
    }, 100);

    return () => {
      driverObj.destroy();
    };
  }, [registration]);

  const getPatientDetailData = () => {
    const wmDiagFlag = BlindPersonForm.getFieldValue('wmDiagFlag')
    if (wmDiagFlag) {
      if (registration?.patientId || registrations?.patientId) {
        // 获取患者信息
        dispatch(
          getPatientDetail(
            registration?.patientId || registrations?.patientId
          )
        )
          .then(unwrapResult)
          .then(async (pateint) => {
            setPatient(pateint)
          })
          .catch(() => {
            // do nothing.
          })
      }

    }
  }

  // 获取个人设置权限
  useEffect(() => {
    if (userId) {
      dispatch(getUserProfileList({ userId: userId, flag: 1}))
        .then(unwrapResult)
        .then((c: any) => {
          setCheckData(c)
        })
    }
  }, [userId])

  const handleOptionSelect = (icds: string, disName: any, disIcds?: any) => {
    setInputValues(prev => ({
      ...prev,
      [icds]: disName
    }));
    setInputIcds(prev => ({
      ...prev,
      [icds]: disIcds
    }));
  }

  const getDiseaseList = (diseaseCode: any, diseaseName?: any) => {
    dispatch(
      getSelectSpecialDiseaseIcd10({
        diseaseCode: diseaseCode,
        cbxz: patientInsurance?.cbxz,
        diseaseName: diseaseName
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDiseaseOptions({
          ...diseaseOptions,
          [diseaseCode]: v,
        })
      })
  }

  const diseasesChose = (v: any) => {
    switch (v.diseTypeCode) {
      case '12':
        BlindPersonForm.setFieldsValue({
          treatmentCategory: TreatmentCategory.Special,
        })
        break
      case '11':
        BlindPersonForm.setFieldsValue({
          treatmentCategory: TreatmentCategory.Slow,
        })
        break
      case '14':
        BlindPersonForm.setFieldsValue({
          treatmentCategory: TreatmentCategory.SlowAndSpecial,
        })
        break
      default:
        if (
          BlindPersonForm.getFieldValue('treatmentCategory') ==
          TreatmentCategory.Special ||
          BlindPersonForm.getFieldValue('treatmentCategory') ==
          TreatmentCategory.Slow ||
          BlindPersonForm.getFieldValue('treatmentCategory') ==
          TreatmentCategory.SlowAndSpecial
        ) {
          BlindPersonForm.setFieldsValue({
            treatmentCategory: TreatmentCategory.Normal,
          })
        }
        break
    }
  }

  const mergeUniqueArrays = (baseArray: any, newArray: any) => {
    const icdsSet = new Set(baseArray.map((item: any) => item.icds));
    const uniqueItems = newArray.filter((item: any) => !icdsSet.has(item.icds));
    return [...baseArray, ...uniqueItems];
  }


  useEffect(() => {
    if (isTipsModalVisible && searchMedical?.length) {
      const result = searchMedical.reduce((obj: any, item: any) => {
        obj[item.diseaseCode] = `${item.diagName?.split('/')?.[0]}`
        return obj
      }, {})
      const resultIcds = searchMedical.reduce((obj: any, item: any) => {
        obj[item.diseaseCode] = item.diagCode
        return obj
      }, {})
      setInputValues(result)
      setInputIcds(resultIcds)

      searchMedical?.map((v: any) => {
        form.setFieldsValue({
          [`diagnosis-${v.diseaseCode}`]: v?.diagName
        })
      })
    }
  }, [isTipsModalVisible, searchMedical])

  useEffect(() => {
    if (!registration || registration == null) {
      return
    }
    const insuranceItem = insuranceArray.find(
      (v) => v.insuranceCode === registration?.insuranceCode
    )
    if (insuranceItem && JSON.stringify(insuranceItem) !== '{}') {
      dispatch(
        setInsurance({
          ...insuranceItem,
          userName,
          userId,
          cycleCode,
          tenantCategory,
          tenantAreaCd,
          name: tenantName,
          address: tenantAddress,
          areaCode: tenantAreaCd,
          endTime: moment(insuranceItem.endTime).format(
            DateTimeFormatSimpleOnlyOne
          ),
        })
      )
    }
  }, [registration])

  useEffect(() => {
    setDeleteFlag(false)
    setAiBtnText("AI写病历")
    setCopyRecipeFlag(false)
  }, [])

  useEffect(() => {
    registrationId &&
      dispatch(searchMedicalAsync({ registrationId: registrationId }))
        .then(unwrapResult)
        .then((v) => {
          if (v?.length) {
            if (v?.[0]?.medicalRecord == 2 && v?.[0]?.localDisease) {
              setIsTipsModalVisible(false)
            } else {
              setIsTipsModalVisible(true)
            }
          }
        })
    registration?.receiveTag && setAgainDiagnoseType(registration.receiveTag == 1) //复诊是否勾选
  }, [registration])

  const storedepartmentId =
    localStorage.getItem('registrationDepartmentId') || departmentId


  // 获取科室
  const getDepartment = () => {
    dispatch(getOutpatientDepartments())
  }

  useEffect(() => {
    getDoctorList(storedepartmentId)
  }, [storedepartmentId])

  const getDoctorList = (departmentId: string) => {
    dispatch(getDoctorsInDepartmentListAsync({ departmentId: departmentId }))
      .then(unwrapResult)
      .then((v: any) => {
        dispatch(getDoctorsInDepartmentTimeListAsync())
          .then(unwrapResult)
          .then((val) => {
            const list = _.chain(v.records)
              .map((u) => U.fromJson(u))
              .value()
            const doctorList = list
              ?.map((n: any) => {
                const lastRegTime = val?.find((item: any) => item.doctorId == n.id)?.lastRegTime
                const time = lastRegTime
                  ? Math.floor((Date.now() - new Date(lastRegTime).getTime()) / (1000 * 60))
                  : null
                return {
                  ...n,
                  lastRegTime: time && time <= 120 ? time : ''
                }
              })
            // 按 lastRegTime 分钟数升序排序
            const hasLastRegTime = doctorList.filter((item: any) => item.lastRegTime).sort((a, b) => {
              const aTime = a.lastRegTime ?? Infinity
              const bTime = b.lastRegTime ?? Infinity
              return bTime - aTime
            })
            const notHasLastRegTime = doctorList.filter((item: any) => !item.lastRegTime)?.map((e: any) => ({
              ...e,
              namePY: pinyin(e.realname, {
                pattern: 'first',
                toneType: 'none',
                separator: '',
              }).toUpperCase()
            }))
              .sort((a: any, b: any) => a.namePY.localeCompare(b.namePY, 'zh-CN')) // 按姓名字母顺序 a在前
            console.log(notHasLastRegTime, hasLastRegTime, [...notHasLastRegTime, ...hasLastRegTime], "sortedDoctorList")
            setDoctors([...notHasLastRegTime, ...hasLastRegTime])
          })
      })
  }

  useEffect(() => {
    if (registration) {
      if (registration.treatmentDepartmentId) {
        getDoctorList(registration.treatmentDepartmentId)
      }
     const flag = doctors?.find(
        (d) =>
          d.id ==
          (registration.treatmentDoctorId || registration.registrationDoctorId)
      )
      treatmentForm.setFieldsValue({
        treatmentDepartmentId:
          registration.treatmentDepartmentId == '0'
            ? undefined
            : registration.treatmentDepartmentId || storedepartmentId,
        treatmentDoctorId:
          registration.treatmentDoctorId == '0'
            ? undefined 
            : flag ? (registration.treatmentDoctorId ||
              registration.registrationDoctorId) : registration.treatmentDoctorName,
      })

      if (
        registration.treatmentDepartmentId == '0' &&
        registration.treatmentDoctorId == '0'
      ) {
        Modal.warn({
          title: '提示',
          content: '暂未指定医生，请先选择接诊医生再填写病历',
        })

      }
      if (!treatment) {
        treatmentForm.setFieldsValue({
          treatmentCategory: TreatmentCategory.Normal,
        })
      }
    }
  }, [dispatch, registration?.registrationDoctorId])

    useEffect(() => {
      if (registration) {
         const flag = doctors?.find(
          (d) =>
            d.id ==
            (registration.treatmentDoctorId || registration.registrationDoctorId)
        )
        treatmentForm.setFieldsValue({
          treatmentDoctorId:
            registration.treatmentDoctorId == '0' 
              ? undefined 
              : flag ? (registration.treatmentDoctorId ||
                registration.registrationDoctorId) : registration.treatmentDoctorName,
        })
      }
    }, [registration?.treatmentDepartmentId,doctors])
    
  useEffect(() => {
    getDepartment()
    if (tenantCategory == 16) {
      getTreatmentAssistantDoctorFn()
    }
  }, [dispatch, tenantCategory])

  // 获取助理医师
  const getTreatmentAssistantDoctorFn = () => {
    dispatch(
      getCounselor({
        current: 1,
        size: 100,
        stationCategory: 8,
      })
    )
      .then(unwrapResult)
      .then(({ records }) => {
        dispatch(getCounselorListTimePage())
          .then(unwrapResult).then((val) => {
            const list = records
              .filter((v: any) => v.kssxbz != 1)
              .filter((v: any) => v.state == 1)
            // 根据返回的list中的id匹配，把第二个接口返回的time字段合并进去
            const enrichedList = list
              ?.map((v: any) => {
                const lastRegTime = val?.find((item: any) => item.doctorId == v.id)?.lastRegTime
                const time = lastRegTime
                  ? Math.floor((Date.now() - new Date(lastRegTime).getTime()) / (1000 * 60))
                  : null
                return {
                  ...v,
                  lastRegTime: time && time <= 120 ? time : '',
                }
              })
            // 按 lastRegTime 分钟数升序排序，null/空 视为最大排最后
            const hasLastRegTime = enrichedList?.filter((item: any) => item.lastRegTime).sort((a: any, b: any) => {
              const aTime = a.lastRegTime ?? Infinity
              const bTime = b.lastRegTime ?? Infinity
              return bTime - aTime
            })
            const notHasLastRegTime = enrichedList
              ?.filter((item: any) => !item.lastRegTime)
              ?.map((e: any) => ({
                ...e,
                namePY: pinyin(e.realname, {
                  pattern: 'first',
                  toneType: 'none',
                  separator: '',
                }).toUpperCase()
              }))
              .sort((a: any, b: any) => a.namePY.localeCompare(b.namePY, 'zh-CN')) // 按姓名字母顺序 a在前
            console.log(notHasLastRegTime, hasLastRegTime, [...hasLastRegTime, ...notHasLastRegTime], 'sortedDoctorList')
            setTreatmentAssistantDoctorList([...notHasLastRegTime, ...hasLastRegTime])
          })
      }
      )
  }

  useEffect(() => {
    if (registration) {
      if (treatmentAssistantDoctorList?.length) {
        const assistantDoctor = treatmentAssistantDoctorList.find(
          (v: any) => v.id == registration?.treatmentAssistantDoctorId
        )
        treatmentForm.setFieldsValue({
          treatmentAssistantDoctorId:
            Number(registration?.treatmentAssistantDoctorId) > -1
              ? Number(registration?.treatmentAssistantDoctorId)
              : undefined,
        })
      }
    }
  }, [registration, treatmentAssistantDoctorList])

  useEffect(() => {
    getRefreshList(registrationId, treatmentId)
    if (!readMode) {
      dispatch(startTreatment(registrationId))
    }
  }, [dispatch, registrationId, treatmentId])

  useEffect(() => {
    setDeleteFlag(false)
    setAiBtnText("AI写病历")
    setCopyRecipeFlag(false)
  }, [])

  // 就诊历史开关记忆（不看其他医生）
  useEffect(() => {
    const historyPanelCheck = localStorage.getItem('historyPanelCheck')
    setSeeOtherDoctor(historyPanelCheck == 'true' ? true : false)
  }, [])

  // 获取就就诊历史
  useEffect(() => {
    if (!registration?.patientId) return
    // 历史病历
    getHistoryList()
  }, [seeOtherDoctor, registration?.patientId])

  useEffect(() => {
    if (!registration?.patientId || !registration?.id) {
      return
    } else {
      dispatch(getTreatmentNotice(registration.patientId))
        .then(unwrapResult)
        .then((notice) => setNotice(notice))
        .catch(() => {
          // do nothing
        })
      getMedicalRecordsShowData()

    }
  }, [registration])

  const getMedicalRecordsShowData = () => {
    dispatch(getMedicalRecordsShow({ patientId: registration?.patientId, registrationId: registration?.id }))
      .then(unwrapResult) //历史信息回显
      .then((res: any) => {
        // 解决闪烁问题
        BlindPersonForm.setFieldsValue({
          ...res,
          historyOfPresentIllness:
            BlindPersonForm.getFieldValue('historyOfPresentIllness') ||
            res?.historyOfPresentIllness,
          pastMedicalHistory:
            BlindPersonForm.getFieldValue('pastMedicalHistory') ||
            res?.pastMedicalHistory,
          allergen: BlindPersonForm.getFieldValue('allergen') || res?.allergen,
          personalHistory:
            BlindPersonForm.getFieldValue('personalHistory') ||
            res.personalHistory,
          familyHistory:
            BlindPersonForm.getFieldValue('familyHistory') || res.familyHistory,
          vaccineHistory:
            BlindPersonForm.getFieldValue('vaccineHistory') || res.vaccineHistory,
          menstrualHistory:
            BlindPersonForm.getFieldValue('menstrualHistory') ||
            res.menstrualHistory,
          maritalHistory:
            BlindPersonForm.getFieldValue('maritalHistory') || res.maritalHistory,
          personalHistoryEnable: BlindPersonForm.getFieldValue('personalHistoryEnable') || !!res.personalHistory,
          familyHistoryEnable: BlindPersonForm.getFieldValue('familyHistoryEnable') || !!res.familyHistory,
          vaccineHistoryEnable: BlindPersonForm.getFieldValue('vaccineHistoryEnable') || !!res.vaccineHistory,
          menstrualHistoryEnable: BlindPersonForm.getFieldValue('menstrualHistoryEnable') || !!res.menstrualHistory,
          maritalHistoryEnable: BlindPersonForm.getFieldValue('maritalHistoryEnable') || !!res.maritalHistory,
          coherentVideo: fileList
            .map((v) => `${v.name}@${v.uid}@`.concat(v.url || ''))
            .join(','),
        })
      })
  }

  const getRefreshList = (registrationId: any, treatmentId: any) => {
    dispatch(
      getTreatment({
        registrationId,
        treatmentId,
        medicalRecord: 2,
      })
    )
  }

  const getBMI = async (v: boolean) => {
    const values = await BlindPersonForm.validateFields()
    let BMI = ''
    if (v && values.patientWeight && values.patientHeight) {
      BMI = (
        (values.patientWeight / (values.patientHeight * values.patientHeight)) *
        10000
      )
        .toFixed(1)
        .toString()
      BlindPersonForm.setFieldsValue({
        BMI,
      })
    } else {
      BMI = ''
    }
    BlindPersonForm.setFieldsValue({
      BMI,
    })
  }

  const getHistoryList = (num?: any) => {
    const [head, tail] = getDateRange(DateRangeType.RecentYear)
    const data = {
      current: 1,
      size: 50,
      medicalRecord: 2,
      treatmentTimeHead: num ? moment().subtract(num, 'year').format(DateTimeFormat) : head,
      treatmentTimeTail: tail,
      patientId: registration?.patientId,
      treatmentDoctorId: seeOtherDoctor ? userId : undefined,
      state: 3,
    }
    dispatch(getTcmTreatmentOldList(data))
      .then(unwrapResult)
      .then((res: any) => {
        setHistoryList(res.records?.map((v: any) => {
          const tgjc = (v?.patientTemperature
            ? '体温：' + v?.patientTemperature + '℃，'
            : '') +
            (v?.patientSystolicPressure
              ? '血压：' + v?.patientSystolicPressure + '/'
              : '') +
            (v?.patientDiastolicPressure
              ? v?.patientDiastolicPressure + 'mmHg，'
              : '') +
            (v?.patientPulse ? '脉搏：' + v?.patientPulse + '次/分，' : '') +
            (v?.patientHeight ? '身高：' + v?.patientHeight + 'cm，' : '') +
            (v?.patientWeight ? '体重：' + v?.patientWeight + 'kg，' : '') +
            (v?.patientWeight && v?.patientHeight
              ? 'BMI:' +
              (
                (v?.patientWeight /
                  (v?.patientHeight * v?.patientHeight)) *
                10000
              ).toFixed(1) +
              '，'
              : '') +
            (v?.patientWaistline ? '腰围：' + v?.patientWaistline + 'cm，' : '') +
            (v.physicalExamination ? v?.physicalExamination : '')
          return {
            ...v,
            tgjc: tgjc
          }
        }))
        const first = res?.records[0]?.id
        setCollapseActivekey(first)
        if (first) {
          dispatch(getRecipeList(first))
            .then(unwrapResult)
            .then((res) => {
              setHistoryData({
                ...historyData,
                [first]: res,
              })
            })
        }
      })
  }

  useEffect(() => {
    if (treatment?.id) {
      dispatch(getRecipeList(treatment?.id))
        .then(unwrapResult)
        .then((recipes: any) => {
          const itemList = recipes?.filter((v: any) => {
            return v?.state == RecipeStatus.Settled
          })
          const SettledState = recipes?.length ? itemList?.length == recipes?.length ? true : false : false
          setSettledState(SettledState)
        })
        .catch(() => {
          // do nothing.
        })
    }
  }, [treatment?.id])


  const copyRecipe = (vs: any) => {
    const params = vs as CopyTreatmentParams
    setIsModalVisible(false)
    if (params.copyRecipe) {
      setIsCopyReciptModalVisible(true)
      setIsCopyReciptParam(params)
    } else {
      dispatch(copyTreatment({ ...params, registrationId, allergen: BlindPersonForm.getFieldValue('allergen') })).then(() => {
        notification.success({
          message: '病历已复制',
        })
        getRefreshList(registrationId, treatmentId)
      })
    }
  }

  const addMessage = (message: any) => {
    setAiMsg((prevMsg) => [...prevMsg, message]);
  };

  const convertToFormText = (d: any, departmentName: string) => {
    // eslint-disable-next-line no-control-regex
    const realD = d?.text?.replace(new RegExp('\r\n', 'g'), '').replace(new RegExp('\n', 'g'), '')

    // 定义每个部分的起始和结束关键字
    const mainComplaintStart = '主诉：';
    const currentIllnessStart = '现病史：';
    const pastHistoryStart = '既往史：';
    const treatmentAdviceStart = '治疗方案：';
    const mxStart = '脉象：';
    const sxStart = '舌象：';
    const bodyCheckStart = '体格检查：';

    // 提取主诉
    const mainComplaintIndex = realD.indexOf(mainComplaintStart);
    const currentIllnessIndex = realD.indexOf(currentIllnessStart);
    if (mainComplaintIndex !== -1) {
      BlindPersonForm.setFieldsValue(
        {
          chiefComplaint: realD.substr(
            mainComplaintIndex + mainComplaintStart.length,
            (currentIllnessIndex - (mainComplaintIndex + mainComplaintStart.length)) < 0 ? realD.length : (currentIllnessIndex - (mainComplaintIndex + mainComplaintStart.length))
          ).trim()
        }
      )

    }

    // 提取现病史
    const pastHistoryIndex = realD.indexOf(pastHistoryStart);
    if (currentIllnessIndex !== -1) {
      BlindPersonForm.setFieldsValue(
        {
          historyOfPresentIllness: realD.substr(
            currentIllnessIndex + currentIllnessStart.length,
            (pastHistoryIndex - (currentIllnessIndex + currentIllnessStart.length)) < 0 ? realD.length : (pastHistoryIndex - (currentIllnessIndex + currentIllnessStart.length))
          ).trim()
        }
      )
    }
    //盲人病历不生成舌象脉象
    if (departmentName && departmentName.indexOf("盲人") >= 0) {
      // 提取既往史
      const bodyCheckStartIndex = realD.indexOf(bodyCheckStart);
      if (pastHistoryIndex !== -1) {
        BlindPersonForm.setFieldsValue(
          {
            pastMedicalHistory: realD.substr(
              pastHistoryIndex + pastHistoryStart.length,
              bodyCheckStartIndex - (pastHistoryIndex + pastHistoryStart.length) < 0 ? realD.length : bodyCheckStartIndex - (pastHistoryIndex + pastHistoryStart.length)
            ).trim()
          }
        )
      }

      // 提取体格检查
      const treatmentAdviceIndex = realD.indexOf(treatmentAdviceStart);
      if (bodyCheckStartIndex !== -1) {
        BlindPersonForm.setFieldsValue(
          {
            physicalExamination: realD.substr(
              bodyCheckStartIndex + bodyCheckStart.length,
              treatmentAdviceIndex - (bodyCheckStartIndex + bodyCheckStart.length) < 0 ? realD.length : treatmentAdviceIndex - (bodyCheckStartIndex + bodyCheckStart.length)
            ).trim()
          }
        )
      }

      // 提取治疗意见
      if (treatmentAdviceIndex !== -1) {
        BlindPersonForm.setFieldsValue(
          {
            treatmentConclusion: realD.substr(
              treatmentAdviceIndex + treatmentAdviceStart.length
            ).trim()
          }
        )
      }
    } else {
      // 提取既往史
      const sxIndex = realD.indexOf(sxStart);
      if (pastHistoryIndex !== -1) {
        BlindPersonForm.setFieldsValue(
          {
            pastMedicalHistory: realD.substr(
              pastHistoryIndex + pastHistoryStart.length,
              sxIndex - (pastHistoryIndex + pastHistoryStart.length) < 0 ? realD.length : sxIndex - (pastHistoryIndex + pastHistoryStart.length)
            ).trim()
          }
        )
      }

      // 提取舌象
      const mxIndex = realD.indexOf(mxStart);
      if (sxIndex !== -1) {
        BlindPersonForm.setFieldsValue(
          {
            tonguePicture: realD.substr(
              sxIndex + sxStart.length,
              mxIndex - (sxIndex + sxStart.length) < 0 ? realD.length : mxIndex - (sxIndex + sxStart.length)
            ).trim()
          }
        )
      }

      // 提取脉象
      const bodyCheckIndex = realD.indexOf(bodyCheckStart);
      if (mxIndex !== -1) {
        BlindPersonForm.setFieldsValue(
          {
            pulseCondition: realD.substr(
              mxIndex + mxStart.length,
              bodyCheckIndex - (mxIndex + mxStart.length) < 0 ? realD.length : bodyCheckIndex - (mxIndex + mxStart.length)
            ).trim()
          }
        )
      }

      // 提取体格检查
      const treatmentAdviceIndex = realD.indexOf(treatmentAdviceStart);
      if (bodyCheckIndex !== -1) {
        BlindPersonForm.setFieldsValue(
          {
            physicalExamination: realD.substr(
              bodyCheckIndex + bodyCheckStart.length,
              treatmentAdviceIndex - (bodyCheckIndex + bodyCheckStart.length) < 0 ? realD.length : treatmentAdviceIndex - (bodyCheckIndex + bodyCheckStart.length)
            ).trim()
          }
        )
      }

      // 提取治疗意见
      if (treatmentAdviceIndex !== -1) {
        BlindPersonForm.setFieldsValue(
          {
            treatmentConclusion: realD.substr(
              treatmentAdviceIndex + treatmentAdviceStart.length
            ).trim()
          }
        )
      }

    }
  }

  useEffect(() => {
    if (aiMsg.length > 0 && aiMsg[aiMsg.length - 1]?.role != "system") {
      let param = {
        registrationId: registrationId,
        timestamp: Date.now(),
        diag: selectedDiseases.map(diag => `${diag.name}(${diag.icds})`).join(', '),
        category: 11,
        departmentName: departments.find(
          (d) => d.id === treatmentForm.getFieldValue("treatmentDepartmentId")
        )?.name
      }
      if ("重写一份" != aiBtnText) {
        param = {
          ...param,
          ...treatmentForm?.getFieldsValue(),
          ...BlindPersonForm?.getFieldsValue(),
        }
      }

      if (param.departmentName && param?.departmentName?.indexOf("盲人") >= 0) {
        setAiPlusText("正在生成盲人病历");
      } else if (param.departmentName && param?.departmentName?.indexOf("针灸") >= 0) {
        setAiPlusText("正在生成针灸病历");
      } else if (param.departmentName && param?.departmentName?.indexOf("推拿") >= 0) {
        setAiPlusText("正在生成推拿病历");
      }


      // 当 aiMsg 有新内容时再调用 API
      HydGPTRun(token, param, {
        onMessage: (d: any) => convertToFormText(d, param.departmentName || "")
      }).then((d: any) => {
        setAiBtnText("重写一份")
        addMessage({
          role: "system",
          content: d?.text
        });
      }).catch((e) => {
        setAiBtnText("AI写病历")
        if (e?.indexOf("MYD-") >= 0) {
          notification.error({ message: e.replace('MYD-', '') })
        } else {
          notification.error({ message: '服务器繁忙，请稍后再试。' })
        }

      }).finally(() => {
        setAiPlusText("");
        setAicheckDone(true);
        formatAiMsg();
      });
    }
  }, [aiMsg]); // 依赖 aiMsg 的变化

  const formatAiMsg = () => {
    //对治疗意见做一次格式化
    const tc = BlindPersonForm.getFieldValue("treatmentConclusion");
    if (tc && tc.indexOf("2.") >= 0 && tc.indexOf("3.") >= 0) {
      //如果是行号1开始，则从第二行开始格式化
      if (tc.indexOf("1.") == 0) {
        BlindPersonForm.setFieldsValue(
          {
            treatmentConclusion: tc.replace(/([2-9]\d*\.\s*|\d{2,}\.\s*)/gm, '\n$1')
          }
        )
      } else {
        //如果行号为1不是第一行内容，则所有行全部格式化
        BlindPersonForm.setFieldsValue(
          {
            treatmentConclusion: tc.replace(/(\d+\.\s*)/gm, '\n$1')
          }
        )
      }

    }
    //体格检查格式化
    const tg = BlindPersonForm.getFieldValue("physicalExamination");
    if (tg && tg.indexOf("2.") >= 0 && tg.indexOf("3.") >= 0) {
      //如果是行号1开始，则从第二行开始格式化
      if (tg.indexOf("1.") == 0) {
        BlindPersonForm.setFieldsValue(
          {
            physicalExamination: tg.replace(/([2-9]\d*\.\s*|\d{2,}\.\s*)/gm, '\n$1')
          }
        )
      } else {
        //如果行号为1不是第一行内容，则所有行全部格式化
        BlindPersonForm.setFieldsValue(
          {
            physicalExamination: tg.replace(/(\d+\.\s*)/gm, '\n$1')
          }
        )
      }

    }
  }

  const submit = async (notSaveEditFlag?: any, isNotModifySign?: any, saveFlag?: any) => {
   const treatmentValues = await treatmentForm.validateFields()
    console.log(treatmentValues, doctors, doctors?.find((v) => v?.id == treatmentValues?.treatmentDoctorId)?.name, "获取医生字段，不要删掉");
    if (!doctors?.find((v) => v?.id == treatmentValues?.treatmentDoctorId)?.name) {
      notification.info({
        message: '该科室下找不到该医生，如需修改病历，请先修改接诊的科室/医生'
      })
      return
    }
    if (creatingState === LoadingState.Loading) {
      return
    }
    if (selectedDiseases.length === 0) {
      setIsDiseaseEmpty(true)
    }
    try {
      const diagnosisValues = await BlindPersonForm.validateFields()
      const treatmentValues = await treatmentForm.validateFields()
      const newTreatment = {
        ...diagnosisValues,
        ...treatmentValues,
        id: treatment?.id,
        medicalRecord: 2,
        registrationId: registration?.id || registrationId,
        patientId: registration?.patientId,
        receiveTag: againDiagnoseType ? VisitType.Subsequence : VisitType.First,
        disease: selectedDiseases.map((d) => `${d.name}/${d.icds}`).join(','),
        treatmentDepartmentName: departments.find(
          (d) => d.id === treatmentValues.treatmentDepartmentId
        )?.name,
        treatmentDoctorName: doctors?.find(
          (d) => d.id === treatmentValues.treatmentDoctorId
        )?.name,
        treatmentAssistantDoctorName: treatmentAssistantDoctorList?.find(
          (n) => n.id === treatmentValues.treatmentAssistantDoctorId
        )?.realname,
        infectiousDisease: treatmentValues.infectiousDisease ? 1 : 0,
        personalHistory: diagnosisValues.personalHistoryEnable
          ? diagnosisValues.personalHistory
          : '',
        familyHistory: diagnosisValues.familyHistoryEnable
          ? diagnosisValues.familyHistory
          : '',
        vaccineHistory: diagnosisValues.vaccineHistoryEnable
          ? diagnosisValues.vaccineHistory
          : '',
        menstrualHistory: diagnosisValues.menstrualHistoryEnable
          ? diagnosisValues.menstrualHistory
          : '',
        maritalHistory: diagnosisValues.maritalHistoryEnable
          ? diagnosisValues.maritalHistory
          : '',
        diseaseType: '3',
        insuranceCode: registration?.insuranceCode,
        reuseTreatmentId: reuseTreatmentId || undefined,
        coherentVideo: fileList
          .map((v) => `${v.name}@${v.uid}@`.concat(v.url || ''))
          .join(','),
      }
      setIsCreating(true)
      dispatch(setTreatmentCreatingState(LoadingState.Loading))
      // if (selectedDiseases.length) {
      // isNotModifySign点击诊断书打印标志位 如果是诊断书保存时多传一个参数
      const paramsData = isNotModifySign
        ? { ...newTreatment, isNotModifySign: true }
        : { ...newTreatment }
      await dispatch(createTreatment(paramsData))
        .then(unwrapResult)
        .then(() => {
          notification.success({ message: '保存成功' })
          getRefreshList(registrationId, treatmentId)
        })
        .finally(() => {
          setIsCreating(false)
          if (saveFlag == 1) {
            if (query.get('cfcxFlag')) {
              dispatch(
                traceRoute({
                  name: '医生工作站',
                  path: '/doctor/station',
                  state: {
                    station: query.get('station'),
                  },
                })
              )
            } else if (query.get('wpcfFlag')) {
              dispatch(
                traceRoute({
                  name: '外配处方',
                  path: '/outRecipe',
                  state: {
                    backSelectTab: '2'
                  }
                })
              )
            } else if (query.get('kskdFlag')) {
              dispatch(
                traceRoute({
                  name: credentials?.isAskMedicine == 1
                    ? '处方申请'
                    : '快速开单',
                  path: '/retail',
                })
              )
            } else if (query.get('ydkdFlag')) {
              dispatch(
                traceRoute({
                  name: '药店开单',
                  path: '/pharmacy/retail',
                })
              )
            } else {
              dispatch(
                traceRoute({
                  name: '医生门诊',
                  path: '/patients',
                })
              )
            }
            return
          } else {
            if (notSaveEditFlag) {
              return
            } else {
              saveEdit()
            }
          }
        })

    } catch (e) {
      return Promise.reject(e)
    } finally {
      dispatch(setTreatmentCreatingState(LoadingState.Finished))
    }
    return Promise.resolve()
  }

  useImperativeHandle(ref, () => ({
    submit: () => submit(),
    showTreatments: () => setIsModalVisible(true),
  }))

  useEffect(() => {
    if (treatmentAssistantDoctorList?.length == 0) {
      getTreatmentAssistantDoctorFn()
    }
  }, [])

  const saveSubmit = async (saveFlag?: any) => {
    const flag = localStorage.getItem('FIRSTNOXY')
    const treatmentDoctorIdNoNumber = !isNaN(
      Number(treatmentForm.getFieldValue('treatmentDoctorId'))
    )
    // 勾选过下次不再提示
    if (flag == '1') {
      await submit(false, false, saveFlag)
    } else {
      if (registrations?.insuranceCode !== 'ZIFEI') {
        if (
          selectedDiseases?.length &&
          selectedDiseases?.[0]?.diagType != 1 &&
          selectedDiseases?.[0]?.diagType
        ) {
          Modal.confirm({
            centered: true,
            title: '',
            content: (
              <>
                <div>
                  <ExclamationCircleFilled
                    style={{ color: '#FFAE55', fontSize: 18 }}
                  />
                  &nbsp;主诊断非西医诊断，有医保扣款风险，是否确定保存？
                </div>
                <div style={{ position: 'relative', bottom: -60 }}>
                  <Checkbox
                    onChange={({ target }) => {
                      const { checked } = target
                      const flag = checked ? '1' : '0'
                      localStorage.setItem('FIRSTNOXY', flag)
                    }}
                    style={{ margin: '10px 0' }}
                  >
                    下次不再提示
                  </Checkbox>
                </div>
              </>
            ),
            okText: '确认',
            cancelText: '取消',
            icon: null,
            onOk: async () => {
              await submit(false, false, saveFlag)
            },
            onCancel: () => {
              return
            },
          })
        } else {
          await submit(false, false, saveFlag)
        }
      } else {
        await submit(false, false, saveFlag)

      }
    }
  }

  // 获取相关影像
  useEffect(() => {
    if (registrations?.patientId) {
      getLastPic()
    }
  }, [registrations?.patientId])

  const getLastPic = () => {
    dispatch(getBlindFileListPage({ patientId: registrations?.patientId }))
      .then(unwrapResult)
      .then((res: any) => {
        const list = res?.coherentVideo ? res?.coherentVideo?.split(',')?.map((v: any) => {
          return ({
            name: v.split('@')[0],
            uid: v.split('@')[1] ? v.split('@')[1] : v.split('@')[0],
            url: v.split('@')[2] ? v.split('@')[2] : v.split('@')[0],
          } as unknown) as UploadFile
        }) : []
        console.log(res, list, "listlistlist")
        setLookPicList(list || [])
        setLastUploadTime(res?.createTime ? moment(res?.createTime).format(DateTimeFormatSimpleOnly) : '-')
      })
  }

  return (
    <div
      className={styles.blindPersonmedicalMain}
    >
      {/* tab上方显示的接诊时间以及偏好设置的按钮 */}
      <Row
        className={styles.preferencesSet}
        align='middle'
      >
        <a
          type='text'
          className={styles.preferencesSetTime}
        >
          接诊时间：{registration?.treatmentTime ? moment(registration?.treatmentTime).format('YYYY/MM/DD') : '-'}
        </a>
        <div
          className={styles.preferencesSetting}
          onClick={() => {
            setiPreferencesSetShow(true)
          }}
        >
          <SettingOutlined
            className={styles.preferencesSettingIcon}
          />
          <a
            type='text'
            className={styles.preferencesSettingText}
          >
            偏好设置
          </a>
        </div>
      </Row>
      {/* 整体布局 */}
      <Row
        className={styles.container}
        wrap={false}
      >
        {/* 左侧诊断模板 */}
        <Col
          className={styles.leftContainer}
          style={{
            backgroundColor: theme.pn,
            borderRadius: theme.br,
          }}
        >
          <Label label='诊断模板' style={{ marginLeft: 20 }} />
          <Divider />
          <DiagnosisTemplate
            templateModalVasible={SaveTemplateModalVasible}
            setFormValues={((d: any, t: any) => {
              BlindPersonForm.setFields([
                { name: 'tcmCase', errors: [] },
              ])
              BlindPersonForm.setFieldsValue({
                ...d,
                disease: '',
                allergen: BlindPersonForm.getFieldValue('allergen') || d?.allergen || '',
                treatmentCategory: d.treatmentCategory == 0 || d.treatmentCategory == -1
                  ? TreatmentCategory.Normal
                  : d.treatmentCategory || TreatmentCategory.Normal,
                personalHistoryEnable: !!d.personalHistory,
                familyHistoryEnable: !!d.familyHistory,
                vaccineHistoryEnable: !!d.vaccineHistory,
                menstrualHistoryEnable: !!d.menstrualHistory,
                maritalHistoryEnable: !!d.maritalHistory,
                patientWaistline: d?.patientWaistline > 0 ? d?.patientWaistline : undefined
              })
              if (d?.patientWeight && d?.patientHeight) {
                const BMI = (
                  (d?.patientWeight /
                    (d?.patientHeight * d?.patientHeight)) *
                  10000
                ).toFixed(1)
                BlindPersonForm.setFieldsValue({
                  BMI,
                })
              }
              const diseases = _.chain(d.disease)
                .split(',')
                .map((s) => s.split('/'))
                .map(
                  ([n, c]) =>
                    ({ name: n, icds: c } as Disease)
                )
                .value()
              setSelectedDiseases(diseases)
              setIsDiseaseEmpty(diseases.length === 0)
            })}
            targetTemplate={targetTemplate}
            cancelTemplate={() => {
              setTargetTemplate(undefined)
              setSaveTemplateModalVasible('false')
            }}
            templateData={(v?: any) => {
              setTemplates(v)
            }}
          />
        </Col>
        {/* 中心部分 */}
        <Col
          flex='1'
          style={{
            borderRadius: readMode ? `0 0 0 ${theme.br}px` : `${theme.br}px`,
            backgroundColor: theme.pn,
          }}
          className={styles.containerForm}
        >
          <Form form={treatmentForm} colon={false} className={styles.titleSelect}>
            {/* 中心部分的科室医生 */}
            <Row
              justify='space-between'
              className={styles.titleSelectRow}
            >
              <Row
                className={styles.titleSelectRowMain}
                gutter={10}
              >
                <Col span={7}>
                  <Form.Item
                    label='科室'
                    name='treatmentDepartmentId'
                    {...columnLayout}
                  >
                    <Select
                      onChange={(v) => {
                        treatmentForm.setFieldsValue({
                          treatmentDoctorId: undefined,
                        })
                        getDoctorList(v)
                      }}
                    >
                      {departments.map((d) => (
                        <Select.Option key={d.id} value={d.id}>
                          {d.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={7} className={styles.selectDisplay}>
                  <Form.Item
                    label='医生'
                    name='treatmentDoctorId'
                    {...columnLayout}
                    rules={[
                      {
                        required: true,
                        message: '接诊医生不能为空',
                      },
                    ]}
                  >
                    <Select dropdownClassName={styles.selectDropdown}>
                      {doctors?.map((d: any) => (
                        <Select.Option key={d.id} value={d.id} >
                          <span>{d.name}</span>
                          {d?.lastRegTime ? <span className={styles.lastRegTime}>（</span> : ''}
                          <span style={{ color: '#ff8345' }} className={styles.lastRegTime}>{d.lastRegTime ? `${d.lastRegTime}min` : ''}</span>
                          {d?.lastRegTime ? <span className={styles.lastRegTime}>）</span> : ''}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6} className={styles.selectDisplay}>
                  <Form.Item
                    label='助理'
                    name='treatmentAssistantDoctorId'
                    {...columnLayout}
                  >
                    <Select dropdownClassName={styles.selectDropdown}>
                      {treatmentAssistantDoctorList?.map((d) => (
                        <Select.Option key={d.id} value={d.id} >
                          <span>{d.realname}</span>
                          {d?.lastRegTime ? <span>（</span> : ''}
                          <span style={{ color: '#ff8345' }}>{d.lastRegTime ? `${d.lastRegTime}min` : ''}</span>
                          {d?.lastRegTime ? <span>）</span> : ''}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={3} className={styles.rightFollowUp}>
                  <Checkbox
                    checked={againDiagnoseType}
                    onChange={(e) => {
                      setReuseTreatmentId('')
                      setAgainDiagnoseType(e.target.checked)
                    }}
                  >
                    复诊
                  </Checkbox>
                </Col>
              </Row>
            </Row>
          </Form>
          <Col className={styles.bottomContainerForm}>
            <Form
              form={BlindPersonForm}
              colon={false}
              className={styles.info}
              autoComplete='off'
              labelCol={{
                flex: '6.5rem',
              }}
              style={{ marginRight: 10 }}
            >
              {registration?.remark ? (
                <span
                  style={{
                    marginLeft: '112px',
                    position: 'relative',
                    top: '-2px',
                    color: '#027aff',
                  }}
                >
                  备注：{registration?.remark.replace('#', ',')}
                </span>
              ) : (
                ''
              )}
              <Form.Item label='主诉' name='chiefComplaint'>
                <FastInput action='zhusu' medicalRecord={2} placeholder={'请输入主诉内容'} />
              </Form.Item>
              <Form.Item
                label='现病史'
                name='historyOfPresentIllness'
                rules={[
                  {
                    max: 6000,
                    message: '最长6000位!',
                  },
                ]}
              >
                <FastInput action='xianbing' placeholder={'请输入现病史内容'} />
              </Form.Item>
              {lxbxsNewFlag ?
                <Form.Item label='流行病学史'
                  name='lxbsContent'
                 >
                  <HistoricalEpidemiologyFastInput value={BlindPersonForm?.getFieldValue('lxbsContent')} />
                </Form.Item>
                : (
                  <></>
                )}
              <Form.Item
                label='既往史'
                name='pastMedicalHistory'
                rules={[
                  {
                    max: 500,
                    message: '最长500位!',
                  },
                ]}
              >
                <FastInput action='jiwang' placeholder={'请输入既往史内容'} />
              </Form.Item>
              <Form.Item
                label='过敏史'
                name='allergen'
                rules={[
                  {
                    max: 500,
                    message: '最长500位!',
                  },
                ]}
              >
                <FastInput action='guoming' placeholder={'请输入过敏史内容'} />
              </Form.Item>
              <Form.Item label='病史'>
                <Row
                  className={styles.medicalHistoryRowMain}
                  align='middle'
                >
                  <Form.Item
                    noStyle
                    name='personalHistoryEnable'
                    valuePropName='checked'
                  >
                    <Checkbox>个人史</Checkbox>
                  </Form.Item>
                  <Form.Item
                    noStyle
                    name='familyHistoryEnable'
                    valuePropName='checked'
                  >
                    <Checkbox>家族史</Checkbox>
                  </Form.Item>
                  <Form.Item
                    noStyle
                    name='vaccineHistoryEnable'
                    valuePropName='checked'
                  >
                    <Checkbox>疫苗接种史</Checkbox>
                  </Form.Item>
                  <Form.Item
                    noStyle
                    name='menstrualHistoryEnable'
                    valuePropName='checked'
                  >
                    <Checkbox>月经史</Checkbox>
                  </Form.Item>
                  {registrations?.patientSex == 2 ?
                    <Form.Item
                      noStyle
                      name='maritalHistoryEnable'
                      valuePropName='checked'
                    >
                      <Checkbox>婚育史</Checkbox>
                    </Form.Item> :
                    <></>}
                </Row>
              </Form.Item>
              <Form.Item dependencies={['personalHistoryEnable']} noStyle>
                {({ getFieldValue }) =>
                  getFieldValue('personalHistoryEnable') && (
                    <Form.Item
                      label='个人史'
                      name='personalHistory'
                      rules={[
                        {
                          max: 200,
                          message: '最长200位!',
                        },
                      ]}
                    >
                      <FastInput action='geren' placeholder={'请输入个人史内容'} />
                    </Form.Item>
                  )
                }
              </Form.Item>
              <Form.Item dependencies={['familyHistoryEnable']} noStyle>
                {({ getFieldValue }) =>
                  getFieldValue('familyHistoryEnable') && (
                    <Form.Item
                      label='家族史'
                      name='familyHistory'
                      rules={[
                        {
                          max: 200,
                          message: '最长200位!',
                        },
                      ]}
                    >
                      <FastInput action='jiazu' placeholder={'请输入家族史内容'} />
                    </Form.Item>
                  )
                }
              </Form.Item>
              <Form.Item dependencies={['vaccineHistoryEnable']} noStyle>
                {({ getFieldValue }) =>
                  getFieldValue('vaccineHistoryEnable') && (
                    <Form.Item
                      label='疫苗接种史'
                      name='vaccineHistory'
                      rules={[
                        {
                          max: 200,
                          message: '最长200位!',
                        },
                      ]}
                    >
                      <FastInput action='ymjzs' placeholder={'请输入疫苗接种史内容'} />
                    </Form.Item>
                  )
                }
              </Form.Item>
              <Form.Item dependencies={['menstrualHistoryEnable']} noStyle>
                {({ getFieldValue }) =>
                  getFieldValue('menstrualHistoryEnable') && (
                    <Form.Item
                      label='月经史'
                      name='menstrualHistory'
                      rules={[
                        {
                          max: 200,
                          message: '最长200位!',
                        },
                      ]}
                    >
                      <FastInput action='yuejin' placeholder={'请输入月经史内容'} />
                    </Form.Item>
                  )
                }
              </Form.Item>
              {registrations?.patientSex == 2 ? <Form.Item dependencies={['maritalHistoryEnable']} noStyle>
                {({ getFieldValue }) =>
                  getFieldValue('maritalHistoryEnable') && (
                    <Form.Item
                      label='婚育史'
                      name='maritalHistory'
                      rules={[
                        {
                          max: 200,
                          message: '最长200位!',
                        },
                      ]}
                    >
                      <FastInput action='hunyu' placeholder={'请输入婚育史内容'} />
                    </Form.Item>
                  )
                }
              </Form.Item> :
                <></>}
              <Form.Item label='体格检查'>
                <Row
                  // style={{ height: 35, position: 'relative' }}
                  className={styles.checkGroup}
                >
                  <Col style={{ width: '13%' }}>
                    <Form.Item
                      noStyle
                      name='patientTemperature'
                      rules={[
                        {
                          message: '请输入最多带一位小数的数值',
                          pattern: new RegExp(/^[0-9]+((\.)[0-9]?)?$/),
                        },
                      ]}
                    >
                      <Input
                        maxLength={4}
                        addonAfter='℃，'
                        placeholder='体温'
                        onChange={(v) => {
                          const value = v?.target?.value
                          setDeleteFlag(false)
                          if (!deleteFlag) {
                            if (value.indexOf('.') !== -1) {
                              BlindPersonForm.setFieldsValue({
                                patientTemperature: value,
                              })
                            } else {
                              if (value?.length == 2) {
                                BlindPersonForm.setFieldsValue({
                                  patientTemperature: value + '.',
                                })
                              } else if (value?.length == 3) {
                                BlindPersonForm.setFieldsValue({
                                  patientTemperature:
                                    value.slice(0, 2) + '.' + value.slice(2),
                                })
                              } else {
                                BlindPersonForm.setFieldsValue({
                                  patientTemperature: value,
                                })
                              }
                            }
                          }
                          if (v?.target?.value?.length == 4) {
                            if (/(\.\.)/.test(value)) {
                              BlindPersonForm.setFieldsValue({
                                patientTemperature: value.slice(
                                  0,
                                  value?.length - 1
                                ),
                              })
                            } else {
                              patientSystolicPressureRef?.current?.focus()
                            }
                          }
                        }}
                        onPressEnter={() => {
                          patientSystolicPressureRef?.current?.focus()
                          const value = BlindPersonForm.getFieldValue(
                            'patientTemperature'
                          )
                          if (value?.length == 3 && value.indexOf('.') !== -1) {
                            BlindPersonForm.setFieldsValue({
                              patientTemperature: value.slice(0, 2),
                            })
                          }
                        }}
                        onBlur={() => {
                          const value = BlindPersonForm.getFieldValue(
                            'patientTemperature'
                          )
                          if (value?.length == 3 && value.indexOf('.') !== -1) {
                            BlindPersonForm.setFieldsValue({
                              patientTemperature: value.slice(0, 2),
                            })
                          }
                        }}
                        onKeyDown={(e) => {
                          // 允许使用 Backspace 和 Delete 键进行删除
                          if (e.key === 'Backspace' || e.key === 'Delete') {
                            setDeleteFlag(true)
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Row style={{ width: '33%' }}>
                    <Col style={{ width: '36%' }}>
                      <Form.Item
                        name='patientSystolicPressure'
                        rules={[
                          {
                            message: '请输入整数值',
                            pattern: new RegExp(/^[0-9]+$/),
                          },
                        ]}
                      >
                        <Input
                          className={Number(patientSystolicPressureValue) > 140 || Number(BlindPersonForm?.getFieldValue('patientSystolicPressure')) > 140 ? styles.textColore47a1f : styles.textColor}
                          maxLength={3}
                          placeholder='收缩压'
                          ref={patientSystolicPressureRef}
                          onChange={(v) => {
                            setPatientSystolicPressureValue(v?.target?.value)
                            if (v?.target?.value?.length == 3) {
                              patientDiastolicPressureRef?.current?.focus()
                            }
                          }}
                          onPressEnter={() => {
                            patientDiastolicPressureRef?.current?.focus()
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      style={{
                        paddingLeft: 9,
                        paddingTop: 5,
                      }}
                    >
                      /
                    </Col>
                    <Col style={{ flex: 1 }} className={Number(patientDiastolicPressureValue) > 90 || Number(BlindPersonForm?.getFieldValue('patientDiastolicPressure')) > 90 ? styles.textColore47a1fContent : styles.textColor}>
                      <Form.Item
                        name='patientDiastolicPressure'
                        rules={[
                          {
                            message: '请输入整数值',
                            pattern: new RegExp(/^[0-9]+$/),
                          },
                        ]}
                      >
                        <Input
                          maxLength={3}
                          addonAfter='mmHg，'
                          placeholder='舒张压'
                          ref={patientDiastolicPressureRef}
                          onChange={(v) => {
                            setPatientDiastolicPressureValue(v?.target?.value)
                            if (v?.target?.value?.length == 3) {
                              patientPulseRef?.current?.focus()
                            }
                          }}
                          onPressEnter={() => {
                            patientPulseRef?.current?.focus()
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Col style={{ width: '15%' }}>
                    <Form.Item
                      name='patientPulse'
                      rules={[
                        {
                          message: '请输入整数值',
                          pattern: new RegExp(/^[0-9]+$/),
                        },
                      ]}
                    >
                      <Input
                        maxLength={5}
                        addonAfter='次/分，'
                        placeholder='脉搏'
                        ref={patientPulseRef}
                        onChange={(v) => {
                          if (v?.target?.value?.length == 3) {
                            patientHeightRef?.current?.focus()
                          }
                        }}
                        onPressEnter={() => {
                          patientHeightRef?.current?.focus()
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col style={{ width: '13%' }}>
                    <Form.Item
                      name='patientHeight'
                      rules={[
                        {
                          message: '请输入最多带两位小数的数值',
                          pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                        },
                      ]}
                    >
                      <Input
                        maxLength={5}
                        addonAfter='cm，'
                        placeholder='身高'
                        onChange={async (e) => {
                          const v = e.target.value
                          getBMI(!!v)
                          if (v?.length == 3) {
                            patientWeightRef?.current?.focus()
                          }
                        }}
                        ref={patientHeightRef}
                        onPressEnter={() => {
                          patientWeightRef?.current?.focus()
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col style={{ width: '13%' }}>
                    <Form.Item
                      name='patientWeight'
                      rules={[
                        {
                          message: '请输入最多带两位小数的数值',
                          pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                        },
                      ]}
                    >
                      <Input
                        maxLength={4}
                        addonAfter='kg，'
                        placeholder='体重'
                        onChange={async (e) => {
                          const v = e.target.value
                          getBMI(!!v)
                        }}
                        ref={patientWeightRef}
                      />
                    </Form.Item>
                  </Col>
                  <Col style={{ width: '13%' }}>
                    <Form.Item name='BMI'>
                      <Input addonBefore='BMI' disabled />
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
              <Form.Item label=' ' name='physicalExamination' rules={[
                {
                  max: 500,
                  message: '最长500位!',
                },
              ]}>
                <FastInput action='tigejiancha' placeholder='请输入其他体格检查内容' />
              </Form.Item>
              <Form.Item
                label='辅助检查'
                name='inspectionCheck'
                rules={[
                  {
                    max: 500,
                    message: '最长500位!',
                  },
                ]}
              >
                <TextArea placeholder='请输入辅助检查内容' autoSize />
              </Form.Item>
              <Form.Item
                label='中医诊断'
                name='disease'
                required
                rules={[
                  {
                    max: 500,
                    message: '最长500位!',
                  },
                  () => ({
                    validator: () => {
                      if (isDiseaseEmpty) {
                        return Promise.reject('请输入中医诊断内容')
                      }
                      return Promise.resolve()
                    },
                  }),
                ]}
              >
                <Row wrap={false} className={styles.diseaseRow}>
                  <Col span={12}>
                    <DiseaseInput
                      isWubi={checkData?.filter((v: any) => v?.code == '5')?.[0]?.codeName}
                      autoFocus={selectedDiseases?.length ? true : false}
                      isMedical={2}
                      insuranceCode={registration?.insuranceCode}
                      disabled={!isDiseaseEditable}
                      placeholder='请输入中医诊断内容'
                      onChange={() => setIsDiseaseEmpty(false)}
                      onSelect={(disease) => {
                        if (
                          !selectedDiseases.find((d) => d.icds === disease.icds)
                        ) {
                          setSelectedDiseases(selectedDiseases.concat(disease))
                          BlindPersonForm.resetFields(['disease'])
                        }
                      }}
                    />
                  </Col>
                  <Col span={6} style={{ marginLeft: '-10px' }}>
                    <Form.Item
                      name='treatmentCategory'
                      // name={['disease', 'treatmentCategory']}
                      {...layout}
                    >
                      <Select
                        autoFocus={isOpen}
                        open={isOpen}
                        onClick={() => {
                          setIsOpen(!isOpen)
                        }}
                        onBlur={() => {
                          setIsOpen(false)
                        }}
                      >
                        {registration?.insuranceCode === 'CHONGQING' &&
                          TreatmentCategoriesCQ.map((c) => (
                            <Select.Option key={c} value={c}>
                              {getTreatmentCategoryName(c)}
                            </Select.Option>
                          ))}
                        {registration?.insuranceCode === 'ZHEJIANG' &&
                          TreatmentCategories.map((c) => (
                            <Select.Option key={c} value={c}>
                              {getTreatmentCategoryName(c)}
                            </Select.Option>
                          ))}
                        {registration?.insuranceCode === 'JIANGSU' &&
                          TreatmentCategoriesJS.map((c) => (
                            <Select.Option key={c} value={c}>
                              {getTreatmentCategoryName(c)}
                            </Select.Option>
                          ))}
                        {(registration?.insuranceCode === 'ZIFEI' ||
                          treatment?.insuranceCode === 'ZIFEI') &&
                          TreatmentCategoriesZF.map((c) => (
                            <Select.Option key={c} value={c}>
                              {getTreatmentCategoryName(c)}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  {!aiSwitch ? (
                    <Col span={6} style={{ marginLeft: '-10px' }}>
                      <Form.Item
                        name='infectiousDisease'
                        valuePropName='checked'
                      >
                        <Checkbox style={{ marginLeft: 10 }}>
                          是否传染病
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  ) : (
                    <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                      {!aicheckDone && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={AILoading}
                            style={{ marginLeft: '10px', width: '35px' }}
                          ></img>
                          <div className={styles.loadingText}>{aiPlusText}</div>
                        </div>
                      )}
                      {aicheckDone && (
                        <Button
                          shape='round'
                          type='primary'
                          className={"first-feature"}
                          style={{
                            background:
                              'linear-gradient(to top right, rgb(124 205 237), rgb(151 115 221), rgb(255 32 174))',
                            alignItems: 'center',
                            marginLeft: 10,
                            display: 'flex',
                            borderColor: '#ffffff',
                            fontWeight: 'bold',
                          }}
                          onClick={() => {
                            if (selectedDiseases && selectedDiseases[0]?.name) {
                              //检查协议
                              const agree = localStorage.getItem(
                                'aiagreement_' + userId
                              )
                              if (agree && agree == '1') {
                                setAicheckDone(false)
                                setAiMsg([
                                  {
                                    role: 'system',
                                    content: '1',
                                  },
                                  {
                                    role: 'user',
                                    content: '2',
                                  },
                                ])
                              } else {
                                Modal.confirm({
                                  width: 800,
                                  centered: true,
                                  title: '免责声明',
                                  content: <AiAgreement></AiAgreement>,
                                  okText: '同意并继续',
                                  cancelText: '不同意',
                                  icon: null,
                                  onOk: () => {
                                    localStorage.setItem(
                                      'aiagreement_' + userId,
                                      '1'
                                    )
                                    setAicheckDone(false)
                                    setAiMsg([
                                      {
                                        role: 'system',
                                        content: '1',
                                      },
                                      {
                                        role: 'user',
                                        content: '2',
                                      },
                                    ])
                                  },
                                })
                              }
                            } else {
                              notification.error({
                                message: '请先填写诊断',
                              })
                            }
                          }}
                        >
                          {aiBtnText}
                        </Button>
                      )}
                    </Col>
                  )}
                </Row>
              </Form.Item>
              <Row
                className={styles.diseaseRowMain}
                style={{
                  display: selectedDiseases.length === 0 ? 'none' : undefined,
                }}
              >
                <Col flex='6.5rem' className={styles.diseaseRowLeft} />
                <Col
                  flex='1'
                  className={styles.diseaseContainer}
                >
                  {selectedDiseases.map((d) => (
                    <div key={d.icds} className={styles.disease}>
                      {`${d.name}/${d.icds}`}{' '}
                      <CloseOutlined
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setSelectedDiseases(
                            selectedDiseases.filter((i) => i.icds !== d.icds)
                          )
                        }}
                      />
                    </div>
                  ))}
                </Col>
              </Row>
              <Form.Item label='治疗意见' name='treatmentConclusion' rules={[
                {
                  max: 500,
                  message: '最长500位!',
                },
              ]}>
                <TextArea placeholder='请输入治疗意见内容' autoSize />
              </Form.Item>
              <Form.Item label='相关影像' className={styles.relatedImage}>
                <FileUpload
                  count={fileList.length || 0}
                  files={fileList}
                  onUpload={(v, i) => {
                    setFileList([
                      ...fileList,
                      {
                        uid: v.uid,
                        size: v.size,
                        name: v.name,
                        type: v.type,
                        originFileObj: {} as RcFile,
                        url: i,
                      },
                    ])
                  }}
                >
                </FileUpload>
                <div className={styles.uploadButtonContainer}>
                  <Button
                    className={styles.uploadButton}
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setIsUploadVisible(true)
                    }}
                  >
                    上传附件
                  </Button>
                  {lookPicList?.length ? (
                    <a style={{ marginLeft: '10px' }}
                      onClick={() => {
                        setIsLookPicListModalVisible(true)
                      }}>最近一次上传时间：{lastUploadTime}</a>
                  ) : <></>}
                </div>
                {fileList.map((item) => (
                  <Row
                    className={styles.relatedImageRow}
                    gutter={24}
                    key={item.uid}
                    style={{
                      padding: '10px',
                      width: '300px',
                    }}
                  >
                    <Col flex={1} className={styles.relatedImageNameContent}>
                      <span
                        className={styles.relatedImageName}
                      >
                        {item.name.split('.')[0]}
                      </span>
                      <span
                        style={{
                          verticalAlign: 'middle',
                        }}
                      >
                        .{item.name.split('.')[1]}
                      </span>
                    </Col>
                    <Col span={6}>
                      <a
                        onClick={() => {
                          dispatch(getUrl({ fileName: item.url }))
                            .then(unwrapResult)
                            .then((v: any) => {
                              const proxy =
                                window.location.origin.indexOf(
                                  'his.develop.hydhis.com'
                                ) >= 0
                                  ? '/proxyToOssDevPrivate'
                                  : window.location.origin.indexOf(
                                    'his.test.hydhis.com'
                                  ) >= 0
                                    ? '/proxyToOssTestPrivate'
                                    : window.location.origin.indexOf(
                                      'hydhis.cn'
                                    ) >= 0
                                      ? '/proxyToOssProdPrivate'
                                      : '/proxyToOssProdPrivate'
                              const url =
                                (window.location.origin?.includes('localhost')
                                  ? 'http://hydhis.cn'
                                  : window.location.origin) +
                                proxy +
                                v
                              setLookPic(url)
                              setIsLookPicModalVisible(true)
                              // window.open(v.replace('http:', 'https:'), '_blank')
                            })
                        }}
                      >
                        查看
                      </a>
                    </Col>
                    <Col span={6}>
                      <CloseOutlined
                        onClick={() => {
                          //  e.stopPropagation();
                          setFileList(() =>
                            fileList.filter((ite) => ite.uid !== item.uid)
                          )
                        }}
                      />
                    </Col>
                  </Row>
                ))}
              </Form.Item>
            </Form>
          </Col>
          <Row
            justify='space-between'
            style={{
              marginBottom: '180px',
              marginTop: hisVersion == 1 ? '16px' : '10px',
              marginRight: '10px',
            }}
          >
            <Space
              style={{
                marginLeft: 30,
              }}
            >
              <Button
                type='primary'
                disabled={!templates.length}
                onClick={async () => {
                  const values = await BlindPersonForm.validateFields()
                  const data = {
                    ...values,
                    medicalRecord: 2,
                    disease: selectedDiseases
                      .map((d) => `${d.name}/${d.icds}`)
                      .join(','),
                    chiefComplaint: values.chiefComplaint,
                    historyOfPresentIllness: values.historyOfPresentIllness,
                    inspectionCheck: values.inspectionCheck,
                    pulseCondition: values.pulseCondition,
                    tonguePicture: values.tonguePicture,
                    treatmentConclusion: values.treatmentConclusion,
                  }
                  setTargetTemplate(data)
                  setSaveTemplateModalVasible('true')
                }}
              >
                存为模板
              </Button>
            </Space>
            <Space>
              <Popover content={<div>点击会清空已填写的病历信息</div>} title="说明">
                <Button
                  type='primary'
                  ghost
                  onClick={() => {
                    BlindPersonForm.resetFields()
                    setSelectedDiseases([])
                    setFileList([])
                  }}
                >
                  清空
                </Button>
              </Popover>
              {readMode ? undefined : ( // </Button> //   另存为模版 // > //   }} //     } //       // do nothing. //     } catch { //       }); //         itemName: "", //           .join(","), //           .map((d) => `${d.name}/${d.icds}`) //         disease: selectedDiseases //         ...values, //       setTargetTemplate({ //       const values = await TcmCasesForm.validateFields(); //     try { //   onClick={async () => { //   type="primary" // <Button
                <Button
                  type='primary'
                  onClick={() => {
                    setTempType(false)
                    setIsModalVisible(true)
                  }}
                >
                  查看/选择 历史病历
                </Button>
              )}
              <Button
                loading={printLoading}
                type='primary'
                // disabled={!treatment?.id}
                onClick={async () => {
                  setPrintLoading(true)
                  try {
                    await submit(true, true)
                    setIsPrintModalVisible(true)
                    setPrintLoading(false)
                  } catch {
                    setPrintLoading(false)
                    // do nothing.
                  }
                }}
              >
                打印
              </Button>
            </Space>
          </Row>
        </Col>
        {/* 右侧内容 */}
        <Col
          style={{
            width: 330,
            height: '100%',
            overflow: 'auto',
            marginLeft: 10,
            backgroundColor: theme.pn,
            position: 'relative',
            borderRadius: readMode ? `0 0 ${theme.br}px 0` : `${theme.br}px`,
          }}
        >
          <Tabs
            centered
            style={{ width: '100%', height: '100%' }}
            tabBarStyle={{
              marginBottom: 5,
            }}
            className={styles.tabs}
          >
            <TabPane
              tab={
                <span style={{ fontSize: '17px', fontWeight: 550 }}>
                  就诊历史
                </span>
              }
              key='0'
              style={{ height: '100%' }}
            >
              <HistoryPanel
                seeOtherDoctor={seeOtherDoctor}
                historyList={historyList}
                historyData={historyData}
                reuseTreatmentId={reuseTreatmentId}
                onChange={(v: string) => {
                  if (v && !historyData[v]) {
                    dispatch(getRecipeList(v))
                      // dispatch(getRecipeLists({ treatmentId: v, excludeType: 1 }))
                      .then(unwrapResult)
                      .then((res) => {
                        setHistoryData({
                          ...historyData,
                          [v]: res,
                        })
                      })
                  }
                }}
                onCopy={(type: boolean, srcTreatmentId: string) => {
                  copyRecipe({
                    copyRecipe: type,
                    srcTreatmentId,
                  })
                }}
                lookMoreHistoryList={((v) => {
                  getHistoryList(v)
                })}
                CollapseActivekey={CollapseActivekey}
                changeAction={(action, v: any) => {
                  switch (action) {
                    case 'active':
                      setCollapseActivekey(v)
                      break
                    case 'check':
                      setSeeOtherDoctor(v)
                      break
                    case 'again':
                      if (v) {
                        setAgainDiagnoseType(true)
                        setReuseTreatmentId(v)
                      } else {
                        setAgainDiagnoseType(false)
                        setReuseTreatmentId('')
                      }
                      break
                    default:
                      break
                  }
                }}
              />
            </TabPane>
            <TabPane
              tab={
                <span style={{ fontSize: '17px', fontWeight: 550 }} className={"second-feature"} >
                  AI 辅诊
                </span>
              }
              key='1'
              style={{ height: '100%', overflow: 'auto' }}
            >
              {!aiSwitch ? (
                <div style={{ textAlign: 'center', marginTop: 100 }}>
                  <p>您尚未开通此功能</p>
                  <br />
                  <p>如有需要请与服务人员联系。</p>
                </div>
              ) : (
                <AiTreatment
                  setRestoreFlag={setRestoreFlag}
                  setLargeVible={setAiLargeVisible}
                  largeVisible={aiLargeVisible}
                  baseData={baseData}
                  registrationId={registration?.id}
                  treatmentBody={{
                    registration: registrations,
                    diagnosisForm: BlindPersonForm,
                    treatmentForm: treatmentForm,
                    diag: selectedDiseases
                      .map((diag) => `${diag.name}(${diag.icds})`)
                      .join(', '),
                  }}
                ></AiTreatment>
              )}
            </TabPane>
          </Tabs>
        </Col>
      </Row >
      {state == 1 ? (
        <></>
      ) : (
        <Row
          style={{
            width: '100%',
            height: '3.125rem',
            backgroundColor: '#fff',
            paddingRight: '40px',
          }}
          align='middle'
        >
          {notice && notice.recentlyTreatmentTime && (
            <div
              style={{
                marginLeft: 15,
                fontSize: '1rem',
                color: theme.e,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => {
                setTempType(true)
                setIsModalVisible(true)
              }}
            >
              最近就诊：
              {moment(notice.recentlyTreatmentTime).format('YYYY/MM/DD')}
              <Tooltip title={notice?.disease}>
                <span
                  style={{
                    marginLeft: 15,
                    maxWidth: 400,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  疾病名称：{notice?.disease}
                </span>
              </Tooltip>
            </div>
          )}
          <div style={{ flex: 1 }} />
          <Space>
            {settledState ?
              <Button
                style={{
                  height: 36,
                  width: 140,
                  fontSize: 20,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                type='primary'
                ghost
                onClick={async () => {
                  saveSubmit(1)
                }}
                loading={isCreating}
              >
                保存并返回
              </Button> :
              <></>}
            <Button
              type='primary'
              onClick={() => {
                saveSubmit()
              }}
              loading={isCreating}
              style={{
                height: 36,
                width: 140,
                fontSize: 20,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              去开处方
            </Button>
          </Space>
        </Row>
      )}
      <DraggableModal
        title='AI 辅诊'
        visible={aiLargeVisible}
        restore={restoreFlag}
        onMinisize={setRestoreFlag}
        onCancel={() => {
          setAiLargeVisible(false)
        }}
      >
        <AiTreatment
          setRestoreFlag={setRestoreFlag}
          setLargeVible={setAiLargeVisible}
          baseData={baseData}
          registrationId={registration?.id}
          treatmentBody={{
            registration: registrations,
            diagnosisForm: BlindPersonForm,
            treatmentForm: treatmentForm,
            diag: selectedDiseases
              .map((diag) => `${diag.name}(${diag.icds})`)
              .join(', '),
          }}
        />
      </DraggableModal>
      <Modal
        className={styles.history}
        width={1200}
        style={{ height: 720, maxHeight: 720, overflow: 'hidden' }}
        title='历史就诊信息'
        visible={isModalVisible}
        footer={null}
        onCancel={() => {
          treatmentsRef.current?.reset()
          setIsModalVisible(false)
        }}
        destroyOnClose
      >
        <Treatments
          medicalRecord={2}
          // showDiagnosis={false}
          ref={treatmentsRef}
          style={{ height: '100%' }}
          patientId={registration?.patientId}
          treatmentId={notice?.treatmentId}
          tempType={tempType}
          onCopyRecipe={(vs, tip) => {
            const params = vs as CopyRecipeParams
            setIsModalVisible(false)
            setIsCopyReciptModalVisible(true)
            setCopyRecipeFlag(true)
            setIsCopyReciptParam(params)
          }}
          onCopy={copyRecipe}
        />
      </Modal>
      <Modal
        title='温馨提醒'
        visible={isTipsModalVisible}
        width={700}
        footer={null}
        maskClosable={false}
        closable
        onOk={() => {
          setIsTipsModalVisible(false)
          form.resetFields()
          setInputValues({})
          setInputIcds({})
        }}
        onCancel={() => {
          setTimeout(() => {
            setIsTipsModalVisible(false)
          }, 300)
          form.resetFields()
          setInputValues({})
          setInputIcds({})
        }}
      >
        <Text>
          <div>该患者存在备案的特慢病信息，请搜索一个明确诊断，然后点击引用</div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {searchMedical?.map((v: any) => {
              const disease = {
                icds: v.diseaseCode,
                id: v.id,
                name: v.diseaseName,
              }
              return (
                <div
                  style={{
                    display: 'flex',
                    marginTop: '10px',
                    alignItems: 'center',
                  }}
                  key={v.icds}
                >
                  <span
                    style={{
                      width: '220px',
                      color: '#027AFF',
                      padding: '0 10px',
                      cursor: 'pointer',
                      textDecoration: 'underline',
                      fontWeight: 'bold',
                      marginRight: '10px',
                      display: 'flex',
                      justifyContent: 'flex-end'
                    }}
                    key={v.icds}
                  >
                    {`${disease.name}/${disease.icds}`}
                  </span>
                  <div style={{ height: '30px' }}>
                    <Form form={form}>
                      <Form.Item name={`diagnosis-${disease.icds}`} label=''>
                        <Select
                          style={{ width: '330px' }}
                          showSearch
                          onClick={() => {
                            getDiseaseList(disease.icds, inputValues[disease.icds])
                          }}
                          onChange={((e) => {
                            setInputValues((prev) => ({
                              ...prev,
                              [disease.icds]: e,
                            }))
                            setInputIcds((prev) => ({
                              ...prev,
                              [disease.icds]: disease.icds,
                            }))
                            getDiseaseList(disease.icds, e)
                          })}
                          onSearch={(e: any) => {
                            setInputValues((prev) => ({
                              ...prev,
                              [disease.icds]: e,
                            }))
                            setInputIcds((prev) => ({
                              ...prev,
                              [disease.icds]: disease.icds,
                            }))
                            getDiseaseList(disease.icds, e)
                          }}
                          onSelect={(v: any) => {
                            const name = v?.split('/')?.[0]
                            const icds = v?.split('/')?.[1]
                            handleOptionSelect(
                              disease.icds,
                              name,
                              icds
                            )
                          }}
                          filterOption={false}
                          optionFilterProp='children'
                          allowClear
                        >
                          {diseaseOptions?.[disease.icds]?.map((v: any) => {
                            return (
                              <Option value={v.diseaseName} key={v.diseaseName}>
                                {v.disName}/{v.icds}
                              </Option>
                            )
                          })}
                        </Select>
                      </Form.Item>
                    </Form>
                  </div>
                  <Button
                    type='primary'
                    size='small'
                    style={{ marginLeft: '20px' }}
                    onClick={() => {
                      const data: any = {
                        icds: inputIcds[disease.icds],
                        name: inputValues[disease.icds],
                        id: disease.id,
                      }
                      if (!inputValues[disease.icds]) {
                        notification.info({
                          message: '请搜索一个明确诊断，然后点击引用'
                        })
                        return
                      }
                      if (
                        !selectedDiseases.find(
                          (d) => d?.icds === inputIcds[disease?.icds]
                        )
                      ) {
                        setSelectedDiseases(selectedDiseases.concat(data)?.filter((v: any) => v?.name))
                        diseasesChose(v)
                      }
                      setIsTipsModalVisible(false)
                      form.resetFields()
                      setInputValues({})
                    }}
                  >
                    引用
                  </Button>
                </div>
              )
            })}
          </div>
        </Text>
        <Row justify='end' style={{ marginTop: '20px' }}>
          <Button
            onClick={() => {
              setIsTipsModalVisible(false)
              form.resetFields()
              setInputIcds({})
              setInputValues({})
            }}
            style={{ marginRight: '10px' }}
          >
            不引用
          </Button>
          <Button
            type='primary'
            onClick={() => {
              const data = searchMedical?.map((v: any) => {
                return {
                  icds: inputIcds[v.diseaseCode],
                  id: v.id,
                  name: inputValues[v.diseaseCode],
                }
              })
              const DiseaseList = mergeUniqueArrays(selectedDiseases, data)
              setSelectedDiseases(DiseaseList?.filter((v: any) => v?.name))
              diseasesChose(searchMedical?.[data?.length - 1])
              setIsTipsModalVisible(false)
              form.resetFields()
              setInputValues({})
              setInputIcds({})
            }}
          >
            全部引用
          </Button>
        </Row>
      </Modal>
      <PreferencesSetModal //偏好设置
        tabNum={'2'}
        isModalVisible={preferencesSetShow}
        handleCancel={() => setiPreferencesSetShow(false)}
        onsubmit={() => {
          PreferencesSetChange && PreferencesSetChange()
          setiPreferencesSetShow(false)
        }}
      />
      <UploadModal
        uploadModalVisible={isUploadVisible}
        accept={'.png,.tiff,.jpg,.jpeg,bmp,.heic,.webp'}
        id={registration?.id || registrationId}
        uploadType={7}
        onCancel={() => {
          setIsUploadVisible(false)
        }}
        maxCount={10}
        onSubmit={(v, i, id) => {
          if (fileList.length + v.length > 10) {
            notification.info({
              message: '已达到最大上传数量，请先删除再上传！',
            })
            return
          }
          dispatch(deleteUploadFileList({ ids: id })).then(unwrapResult)
          setFileList([...fileList, ...v])
          setIsUploadVisible(false)
        }}
      />
      <PrintTemplateModal
        templateCategory={PrintTemplateCategory.Zds}
        visible={isPrintModalVisible && !!treatment?.id}
        treatmentId={treatment?.id}
        onCancel={() => setIsPrintModalVisible(false)}
      />
      <Modal
        visible={isCopyReciptModalVisible}
        footer={null}
        destroyOnClose
        className={styles.modal}
      >
        <div
          style={{
            padding: '32px',
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <InfoCircleOutlined
            style={{
              color: '#faad14',
              marginRight: '10px',
              fontSize: '22px',
            }}
          />
          <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
            是否从处方复制价格？
          </span>
        </div>
        <CloseOutlined
          style={{
            position: 'absolute',
            color: '#8c8c8c',
            right: 10,
            top: 20,
            marginRight: '10px',
            fontSize: '22px',
          }}
          onClick={() => {
            setIsCopyReciptModalVisible(false)
            setcfBtnLoading(false)
            setmlBtnLoading(false)
            setkcBtnLoading(false)
          }}
        />
        <Row
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
          }}
        >
          <Button
            style={{
              marginRight: '14px',
            }}
            loading={mlBtnLoading}
            onClick={() => {
              setmlBtnLoading(true)
              setcfBtnLoading(true)
              setkcBtnLoading(true)
              if (copyRecipeFlag) {
                if (treatment?.id) {
                  dispatch(
                    copyTreatmentRecipe({
                      ...isCopyReciptParam,
                      treatmentId: treatment?.id,
                      copyAmountType: 1,
                    })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '复制成功',
                      })
                      setIsCopyReciptModalVisible(false)
                      getRefreshList(registrationId, treatmentId)
                    })
                    .catch((v) => {
                      setIsCopyReciptModalVisible(false)
                    })
                    .finally(() => {
                      setmlBtnLoading(false)
                      setcfBtnLoading(false)
                      setkcBtnLoading(false)
                    })
                  return
                } else {
                  notification.info({
                    message: '请先保存病历'
                  })
                  setIsCopyReciptModalVisible(false)
                  setmlBtnLoading(false)
                  setcfBtnLoading(false)
                  setkcBtnLoading(false)
                  return
                }
              } else {
                dispatch(
                  copyTreatment({
                    ...isCopyReciptParam,
                    allergen: BlindPersonForm.getFieldValue('allergen'),
                    registrationId,
                    copyAmountType: 0,
                  })
                )
                  .then(unwrapResult)
                  .then(() => {
                    setIsCopyReciptModalVisible(false)
                    notification.success({
                      message: '病历和处方已复制',
                    })
                    getRefreshList(
                      registrationId,
                      treatmentId,
                    )
                  })
                  .catch((v) => {
                    setIsCopyReciptModalVisible(false)
                  })
                  .finally(() => {
                    setmlBtnLoading(false)
                    setcfBtnLoading(false)
                    setkcBtnLoading(false)
                  })
              }
            }}
          >
            使用目录价格
          </Button>
          <Button
            style={{
              marginRight: '14px',
            }}
            loading={cfBtnLoading}
            type='primary'
            onClick={() => {
              setmlBtnLoading(true)
              setcfBtnLoading(true)
              setkcBtnLoading(true)
              if (copyRecipeFlag) {
                if (treatment?.id) {
                  dispatch(
                    copyTreatmentRecipe({
                      ...isCopyReciptParam,
                      treatmentId: treatment?.id,
                      copyAmountType: 1,
                    })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '复制成功',
                      })
                      setIsCopyReciptModalVisible(false)
                      getRefreshList(registrationId, treatmentId)
                    })
                    .catch((v) => {
                      setIsCopyReciptModalVisible(false)
                    })
                    .finally(() => {
                      setmlBtnLoading(false)
                      setcfBtnLoading(false)
                      setkcBtnLoading(false)
                    })
                  return
                } else {
                  notification.info({
                    message: '请先保存病历'
                  })
                  setIsCopyReciptModalVisible(false)
                  setmlBtnLoading(false)
                  setcfBtnLoading(false)
                  setkcBtnLoading(false)
                  return
                }
              } else {
                dispatch(
                  copyTreatment({
                    ...isCopyReciptParam,
                    allergen: BlindPersonForm.getFieldValue('allergen'),
                    registrationId,
                    copyAmountType: 1,
                  })
                )
                  .then(unwrapResult)
                  .then(() => {
                    setIsCopyReciptModalVisible(false)
                    notification.success({
                      message: '病历和处方已复制',
                    })
                    getRefreshList(registrationId, treatmentId)
                  })
                  .catch((v) => {
                    setIsCopyReciptModalVisible(false)
                  })
                  .finally(() => {
                    setmlBtnLoading(false)
                    setcfBtnLoading(false)
                    setkcBtnLoading(false)
                  })
              }
            }}
          >
            使用处方价格
          </Button>
          <Button
            style={{
              marginRight: '14px',
            }}
            loading={kcBtnLoading}
            type='primary'
            onClick={() => {
              setmlBtnLoading(true)
              setcfBtnLoading(true)
              setkcBtnLoading(true)
              if (copyRecipeFlag) {
                if (treatment?.id) {
                  dispatch(
                    copyTreatmentRecipe({
                      ...isCopyReciptParam,
                      treatmentId: treatment?.id,
                      copyAmountType: 1,
                    })
                  )
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '复制成功',
                      })
                      setIsCopyReciptModalVisible(false)
                      getRefreshList(registrationId, treatmentId)
                    })
                    .catch((v) => {
                      setIsCopyReciptModalVisible(false)
                    })
                    .finally(() => {
                      setmlBtnLoading(false)
                      setcfBtnLoading(false)
                      setkcBtnLoading(false)
                    })
                  return
                } else {
                  notification.info({
                    message: '请先保存病历'
                  })
                  setIsCopyReciptModalVisible(false)
                  setmlBtnLoading(false)
                  setcfBtnLoading(false)
                  setkcBtnLoading(false)
                  return
                }
              } else {
                dispatch(
                  copyTreatment({
                    ...isCopyReciptParam,
                    allergen: BlindPersonForm.getFieldValue('allergen'),
                    registrationId,
                    copyAmountType: 2,
                  })
                )
                  .then(unwrapResult)
                  .then(() => {
                    setIsCopyReciptModalVisible(false)
                    notification.success({
                      message: '病历和处方已复制',
                    })
                    getRefreshList(registrationId, treatmentId)
                  })
                  .catch(() => {
                    setIsCopyReciptModalVisible(false)
                  })
                  .finally(() => {
                    setmlBtnLoading(false)
                    setcfBtnLoading(false)
                    setkcBtnLoading(false)
                  })
              }
            }}
          >
            使用库存价格
          </Button>
        </Row>
      </Modal>
      <Modal
        width={800}
        footer={null}
        title=''
        visible={isLookPicModalVisible}
        onOk={(v) => {
          setIsLookPicModalVisible(false)
        }}
        onCancel={(v) => {
          setIsLookPicModalVisible(false)
        }}
      >
        <div
          style={{
            maxHeight: '600px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            marginTop: '40px',
          }}
        >
          <img src={lookPic} style={{ height: '500px', width: 'auto' }}></img>
          <a
            style={{ marginTop: '20px' }}
            onClick={(v) => {
              if (lookPic.indexOf("hydhis.c") >= 0) {
                window.open(lookPic.replace('http:', 'https:'), '_blank')
              } else {
                window.open(lookPic, '_blank')
              }
            }}
          >
            下载
          </a>
        </div>
      </Modal>
      <LookPicModal
        lookPicList={lookPicList}
        isVisible={isLookPicListModalVisible}
        patientId={registration?.patientId}
        onOk={() => {
          setIsLookPicListModalVisible(false)
          setLookPicList([])
          getLastPic()
        }}
        onCancel={() => {
          setIsLookPicListModalVisible(false)
          setLookPicList([])
          getLastPic()
        }}
      />
    </div >
  )
}

export const BlindPersonmedicalCases = forwardRef(BlindPersonmedicalCase)
